import { render, staticRenderFns } from "./visitRecordList.vue?vue&type=template&id=a7674f54&scoped=true&"
import script from "./visitRecordList.vue?vue&type=script&lang=js&"
export * from "./visitRecordList.vue?vue&type=script&lang=js&"
import style0 from "./visitRecordList.vue?vue&type=style&index=0&id=a7674f54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7674f54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7674f54')) {
      api.createRecord('a7674f54', component.options)
    } else {
      api.reload('a7674f54', component.options)
    }
    module.hot.accept("./visitRecordList.vue?vue&type=template&id=a7674f54&scoped=true&", function () {
      api.rerender('a7674f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/bigCustomer/visit/visitRecordList.vue"
export default component.exports